import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import FileSaver from "file-saver";

import { ReactComponent as DownloadIcon } from "src/assets/svg/download.svg";
import Layout from "src/router/AuthenticatedRouter/Layout";
import { getInterview } from "src/network/interview";
import { JobInterview } from "src/types";
import LoaderPage from "src/components/Loader/LoaderPage";
import { customToast } from "src/utils/toast";
import { JobPageTab } from "src/pages/job/detail";
import { JobInterviewClass } from "src/classes/models/job_interview";
import Tabs from "src/components/Tabs";
import Report from "./tabs/Report";
import Recording from "./tabs/Recording";
import Resume from "./tabs/Resume";
import Button from "src/components/Button";
import useSlugParam from "src/hooks/useSlug";
import Job from "src/types/models/Job";
import { getJob } from "src/network/job";
import DownloadReport from "./components/DownloadReport";
import { Feedback } from "src/classes/models/interview";

export type tab = "Report" | "Recording" | "Resume";
const tabs: tab[] = ["Report", "Recording", "Resume"];

const InterviewDetailPage = () => {
  const { id } = useSlugParam();
  const [params] = useSearchParams();
  const tab: tab = (params.get("tab") as tab) || tabs[0];
  const [interview, setInterview] = useState<JobInterview>();
  const [job, setJob] = useState<Job>();
  const [feedback, setFeedback] = useState<Feedback>();

  const getFeedback = async () => {
    if (!id) return;
    try {
      const i = await getInterview({ id });
      if (!i) throw new Error();
      setInterview(i);
      const I = new JobInterviewClass(i);
      setFeedback(I.getParsedFeedback());
    } catch (e) {
      customToast({ message: "Insights are currently unavailable, try again later.." });
    }
  };

  // We need the detailed job
  useEffect(() => {
    if (!interview) return;
    getJob({ id: interview.job_id }).then((j) => setJob(j));
  }, [interview]);

  // Initial Fetch
  useEffect(() => {
    getFeedback();
  }, [id]);

  let Right;
  switch (tab) {
    case "Report": {
      Right = interview && <DownloadReport interview={interview} feedback={feedback} />;
      break;
    }
    case "Resume": {
      // Also allow to download the resume with a non cryptic name
      if (!interview?.resume_presigned) break;
      const I = new JobInterviewClass(interview);
      const handleClick = () => FileSaver.saveAs(interview.resume_presigned, I.getResumeFileName());
      Right = (
        <Button shapeVariant={2} onClick={handleClick}>
          <DownloadIcon className="w-6 h-6 mr-2 stroke-white" />
          Download Resume
        </Button>
      );

      break;
    }
    default:
      break;
  }

  const Content = interview ? (
    <Tabs
      withSearchParam
      tabs={tabs}
      contents={[
        <Report interview={interview} feedback={feedback} setInterview={setInterview} />,
        <Recording interview={interview} job={job} />,
        <Resume interview={interview} />
      ]}
    />
  ) : (
    <LoaderPage />
  );

  return (
    <Layout
      rightChildren={Right}
      title={
        interview ? (
          <>
            <span className="text-odfblue">
              {interview?.first_name || ""} {interview?.last_name || ""}'s{" "}
            </span>
            Interview report for <span className="text-odfblue">{interview.Job.job_title}</span>{" "}
            role.
          </>
        ) : (
          "Loading..."
        )
      }
      back={interview && `/job/${interview?.Job.slug}?tab=${"Interviews" as JobPageTab}`}
    >
      {Content}
    </Layout>
  );
};

export default InterviewDetailPage;
